<template>
  <div>
    <van-popup
      v-model="$store.state.showPopup"
      :class="`${$store.state.xiazApp ? 'popup-conter-app' : 'popup-conter'}`"
      @close="SuporteIs = false"
      :overlay-class="`${$store.state.xiazApp ? 'popup-box-app' : 'popup-box'}`"
      position="left"
    >
      <div
        class="my-scrollbar my-scrollbar-none"
        style="width: 3rem; overflow-x: scroll"
      >
        <div class="X_tOtMUxMTenSfTn7J28 game-menu__items">
          <div
            v-if="!is_vuex_token || (is_vuex_token && item.textName != '_Demo')"
            @click="tabFun(item)"
            :class="
              $store.state.active == index
                ? 'O8zRRZalAqyl6XRHwyev ia6woxHBwCJOiUSohzV6 game-menu__item'
                : ' O8zRRZalAqyl6XRHwyev game-menu__item'
            "
            v-for="(item, index) in iconList"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" class="JGYMaLsdGfKSq3qags9Y" />
            <div class="IDcevVi1oQJGuthlvopy text">{{ item.name }}</div>
          </div>
        </div>
        <div class="vsmXMvkgXQ1ZupbTcU60">
          <div class="yVxgEnjFwfNHfoePIA4w other-group">

            <div  v-if="!hideAppDownload"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
              @click="$store.commit('publicFun', ['AppDownload', true])"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_xz--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">
                {{ $t('popup._BaixarApp') }}
              </div>
            </div>
            <div
              @click="$router.push({ name: 'notice' })"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_kf--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._Suporte') }}</div>
            </div>
            <div
              @click="$router.push({ name: 'notice' })"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_cjwt--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._FAQ') }}</div>
            </div>
            <!-- sy_zc_zdwm--svgSprite -->
            <!-- 'site_about' -->
            <div
              @click="
                $router.push({
                  name: 'details',
                  query: {
                    title: $t('popup._Sobre'),
                    isConter: true,
                    content: $store.state.config.site_about
                  }
                })
              "
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_gywm--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._Sobre') }}</div>
            </div>
            <div
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div
                class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap"
                style="
                  background-color: transparent;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg-icon
                  className="bgcolor"
                  style="
                    width: 0.35rem;
                    height: 0.35rem;
                    color: var(--theme-text-color-lighten);
                  "
                  icon-class="sy_zc_zdwm--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">
                {{ $t('components._Encontre_nos') }}
              </div>
            </div>
          </div>
          <!--  -->
          <div
            class="NQ4WM0y42kgXYhY5nCtm offical-channel"
            v-if="!vuex_token_head"
          >
            <p class="DBxipifklFUXsk1HBEsp">
              {{ $t('components._LoginRpido') }}
            </p>
            <div
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div
                class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap"
                style="
                  background-color: transparent;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  :src="GoogleLOgo"
                  alt=""
                  style="width: 0.3rem; height: 0.3rem"
                  sizes=""
                  srcset=""
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">
                {{ $t('components._GoogleLogin') }}
              </div>
            </div>
          </div>
          <div class="NQ4WM0y42kgXYhY5nCtm offical-channel">
            <p class="DBxipifklFUXsk1HBEsp">
              {{ $t('components._CanalOficial') }}
            </p>
            <!-- ConemUel -->
            <div class="_item_1w1y0_26" @click="openUrlCsusy(config.telegram)">
              <img
                :src="ConemUel"
                style="width: 0.44rem; height: 0.44rem"
                alt=""
                srcset=""
              />
              <span>{{ $t('components._Telegramoficial') }}</span>
            </div>
            <div class="_item_1w1y0_26" @click="openUrlCsusy(config.instagram)">
              <img
                :src="ConemUel"
                style="width: 0.44rem; height: 0.44rem"
                alt=""
                srcset=""
              />
              <span>{{ $t('components._Instagramoficial') }}</span>
            </div>
            <div
              class="_item_1w1y0_26"
              @click="openUrlCsusy(config.online_service)"
            >
              <img
                :src="ConemUel"
                style="width: 0.44rem; height: 0.44rem"
                alt=""
                srcset=""
              />
              <span>{{ $t('components._Siteoficial') }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    </div>
</template>

<script>
import { mapState } from 'vuex';
import {ICON_NAV,ICON_NAVActive,ICON_NAV3Dian6} from '@/assets/public/icon_nav.js';
import Audio from '@/components/audio/index.vue';
export default {
  name: 'Icon',
  computed:{
    ...mapState(['popList','userInfo','moneyInfo','config','vuex_token_head'])
  },
  components:{
    Audio
  },
  props: {
    showPopup:{
      type: Boolean,
      required: false
    }

  },
  // a6oue-4n001.png
  //a5t99-x5dbj.png
  //a9z29-wbe0y.png
  //a9dx2-gu8od.png
  //azxbo-u1ybj.png
  //aks8s-qq8xc.png
  data(){
    return {
      show:false,
      GoogleLOgo:require('./../../assets/4Ddian/aoffx-gl7s6.png'),
      iconList:[
        {name:'Inicio',imgUrl:require('./../../assets/4Ddian/a6oue-4n001.png')},
        {name:'VIP',imgUrl:require('./../../assets/4Ddian/a5t99-x5dbj.png'),router:'vip'},
        {name:'Promoção',imgUrl:require('./../../assets/4Ddian/a9z29-wbe0y.png'),router:'event'},
        {name:'Missão',imgUrl:require('./../../assets/4Ddian/a5vl2-r5eym.png'),router:''},
        {name:'Juros',imgUrl:require('./../../assets/4Ddian/azxbo-u1ybj.png'),router:'yuebao'},
        {name:'Agente',imgUrl:require('./../../assets/4Ddian/aks8s-qq8xc.png'),router:'promote'}
        // yuebao
      ],
      ConemUel:require('./../../assets/4Ddian/1891317513356587009.jpg'),
      activeList:ICON_NAVActive,
      SuporteIs:false,
      _i18nLocale:'',
      is_vuex_token:false,
      hideAppDownload:window.localStorage.getItem('hideAppDownload')
    };
  },
  created() {
    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.is_vuex_token=true;
    }
    if (this.config.ui_version == '3.6') {
      this.iconList = ICON_NAV3Dian6;
    }
    // this.$u.vuex('v_lang', item)
    // this._i18nLocale
    // console.log(this.$i18n.locale)
    // this.$i18n.locale = 'pt';
    // this.SuporteIs=false;
    // console.log(this.$store.state)
  },
  methods: {
    iconName(){
      return `${this.prefix}${this.name}`;
    },
    openUrlCsusy(e) {
      if (e != '#') {
        window.open(e, '_blank');
      }
    },
    switchLang(e = 'en') {
      this.$i18n.locale = e;
      this._i18n.locale = e;
      this.$vuex('_i18nLocale', e);
    },
    tabFun(e){
      if (e.router) {
        this.$router.push({
          name: e.router
        });
      }
      // this.$store.commit('active',e)
      this.$store.commit('showPopup',e);
    }
  }
};
</script>
<style>
.popup-box {
  top: 0.901rem !important;
  height: calc(100% - 0.901rem) !important;
}
.popup-box-app {
  top: 1.61rem !important;
  height: calc(100% - 1.61rem) !important;
}
.popup-conter {
  top: 0.9rem !important;
  height: calc(100% - 0.901rem) !important;
  background-color: var(--theme-main-bg-color) !important;
  max-width: 40% !important;
  bottom: 0;
}
html .popup-conter-app {
  /* top: 55% !important; */
  top: 1.61rem !important;
  height: calc(100% - 1.61rem) !important;
  background-color: var(--theme-main-bg-color) !important;
  max-width: 40% !important;
  bottom: 0;
  /* transform: initial; */
}
.popup-conter.van-popup--left,
.popup-conter-app.van-popup--left {
  transform: initial;
}
</style>
<style>
.van-popup {
  overflow-y: visible !important;
}
</style>
<style scoped>
._item_1w1y0_26 {
  background-color: var(--skin__bs_zc_bg);
  padding: 0.08rem 0;
}
._item_1w1y0_26 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 0.1rem;
  padding: 0.08rem 0.18rem;
  padding-left: 0;
  box-sizing: border-box;
  border-radius: 0.1rem;
}
._item_1w1y0_26 > span {
  width: 100%;
  margin-left: 0.1rem;
  color: var(--skin__lead);
  font-size: 0.22rem;
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 200;
}
.pendant-a1lbS {
  bottom: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
}

.pendant-lt-Pb8Fs,
.pendant-rb-trhWq {
  width: 0.4rem;
  height: 0.4rem;
  background-position: 0 0;
  background-size: 100% 100%;
  position: absolute;
}

.pendant-rb-trhWq {
  bottom: 0;
  right: 0;
}

.pendant-lt-Pb8Fs {
  top: 0;
  left: 0;
}

.searchWrap-AApaE {
  align-items: center;
  background-color: var(--cms-background-color-secondary);
  border-radius: 0.14rem;
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  width: 100%;
  justify-content: space-between;
  padding-right: 0.18rem;
  color: var(--cms-text-color-secondary);
  font-size: 0.22rem;
  padding-left: 0.08rem;
}
.NQ4WM0y42kgXYhY5nCtm {
  margin: 0.2rem 0;
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm .DBxipifklFUXsk1HBEsp {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  font-stretch: normal;
  font-style: normal;
  font-weight: 200;
  letter-spacing: normal;
  line-height: 1.38;
  margin-bottom: 0.12rem;
  text-align: left;
}

.NQ4WM0y42kgXYhY5nCtm .VmQmq_aGsrNiKVkUlbUu {
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm .VmQmq_aGsrNiKVkUlbUu .A_AasZeOJGaSJpKJubX7 {
  -ms-flex-align: center;
  -ms-flex-pack: start;
  align-items: center;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.1rem;
  padding: 0.08rem 0.18rem;
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm
  .VmQmq_aGsrNiKVkUlbUu
  .A_AasZeOJGaSJpKJubX7
  .jmFqfEJv11xtlFSDmS9f {
  height: 0.34rem;
  width: 0.34rem;
}

.NQ4WM0y42kgXYhY5nCtm
  .VmQmq_aGsrNiKVkUlbUu
  .A_AasZeOJGaSJpKJubX7
  .QFyNFwV7f_hn4Tn_gwqJ {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  font-weight: 400;
  margin-left: 0.2rem;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.my-scrollbar {
  height: 100%;
}
.X_tOtMUxMTenSfTn7J28 {
  -ms-flex-pack: justify;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.15rem 0.15rem 0;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev {
  -ms-flex-pack: distribute;
  background: var(--theme-side-menu-btn-color);
  color: var(--theme-text-color);
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: space-around;
}
.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev {
  border-radius: 0.16rem;
  cursor: pointer;
  font-size: 0.2rem;
  height: 1.02rem;
  max-width: 1.3rem;
  margin-bottom: 0.2rem;
  min-width: 1.3rem;
  box-sizing: border-box;
  width: 1.25rem;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev .JGYMaLsdGfKSq3qags9Y {
  margin: 0.13rem auto 0.03rem;
  width: 0.34rem;
  height: auto;
}
.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev .IDcevVi1oQJGuthlvopy {
  font-size: 0.2rem;
  padding: 0 0.04rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev.ia6woxHBwCJOiUSohzV6 {
  background-color: var(--theme-primary-color);
  background-position: 50%;
  background-size: 100% 100%;
  color: var(--theme-primary-font-color);
  position: relative;
  -webkit-transition: all 0.3;
  transition: all 0.3;
}
.vsmXMvkgXQ1ZupbTcU60 {
  padding: 0 0.15rem;
}
.JzmqmQEmD_EojrBge1qC {
  font-size: 0.24rem;
  height: 0.75rem;
  align-items: center;
  display: flex;
  justify-content: space-around;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  cursor: pointer;
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 100%;
}
.JzmqmQEmD_EojrBge1qC_iam {
  width: 0.36rem;
  height: 0.36rem;
}
.yfF9WZOWUEDWBJAnHyPf {
  -ms-flex-pack: justify;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0.1rem 0 0.05rem;
  padding: 0.1rem 0.1rem 0;
  width: 100%;
}
.a6z38LxCJRwWacRIx6d9 {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  padding-bottom: 0.1rem;
  text-align: center;
  width: 2.5rem;
}
._037LxwuCKN9WUGgvrvgg {
  cursor: pointer;
  position: relative;
  margin-bottom: 0.1rem;
  width: 1.2rem;
  height: 0.8rem;
}
._037LxwuCKN9WUGgvrvgg img {
  position: absolute;
  top: 0;
  left: 0;
}
._037LxwuCKN9WUGgvrvgg span {
  position: absolute;
  left: 0.1rem;
  top: 0.06rem;
  font-size: 0.15rem;
  z-index: 9;
  color: #fff;
}
.other-group {
  margin-top: 0.1rem;
}
.contact-us {
  display: flex;
  color: var(--theme-text-color-lighten);
}
.bgcolor {
  color: var(--theme-side-menu-bg-color);
}
.bgcolor_a {
  color: var(--theme-side-menu-bg-color);
  width: 0.14rem !important;
  height: 0.14rem !important;
}
.dDFOAjUKC5bZ6pGH7_p0 {
  width: 0.36rem !important;
  height: 0.36rem !important;
  margin-right: 0.1rem;
  display: flex;
  height: 0.334rem;
  margin-right: 0.193rem;
  background: var(--theme-text-color-lighten);
  border-radius: 50%;
  width: 0.334rem;
}
._llZzyHSRes4dPHH7fN2 {
  font-size: 0.22rem;
  font-weight: 200;
}
.KYJ6GhRbRQ3eAaeyFhEg {
  cursor: pointer;
  font-size: 0.22rem;
  min-height: 0.6rem;
  display: flex;
  align-items: center;
  padding-left: 0.18rem;
}
.ant-popover-inner {
  background: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  position: absolute;
  max-height: 4.7rem;
  right: -1.5rem;
}
.ant-popover-inner .ant-menu-item {
  font-size: 0.24rem;
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.2rem;
}
</style>
